module.exports = __webpack_public_path__ + "img/menu_logo.eb9dcd74.svg";